import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getArrayDocDataByRef,
  getDocDataById,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import { query } from "firebase/firestore";
import { set } from "date-fns";
import WarningButton from "../buttons/WarningButton.js";
import modifyFolderPack from "../api/modify/modifyFolderPack.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";
import DropDownGPT1X from "../dropdowns/DropDownGPT1X.js";
import { addActivityLog } from "../config/OnlineStatus.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import modifyFolderPackBasic from "../api/modify/modifyFolderPackBasic.js";

const ConvertBasic = ({
  document,
  folder,
  orgData,
  onClose,
  onUpdate,
  userData,
}) => {
  const [packs, setPacks] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [pack_documents, setPackDocuments] = useState([]);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [pack, setPack] = useState(null);
  const [loadingData = false, setLoadingData] = useState(false);

  const [couples, setCouples] = useState([]);

  const handleFetchData = async () => {
    if (orgData) {
      const org = orgData;

      const filters = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];
      const all_packs = await queryCollection("prestation", filters);

      // lets order by pack_name
      // remove duplicates

      const documents = await getArrayDocDataByRef(folder.documents);
      setDocuments(documents);

      let pack_options = all_packs.map((pack) => {
        return {
          value: pack.id,
          label: pack.name,
        };
      });

      pack_options = pack_options.sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      setPacks(pack_options);
    }
  };

  const changePack = async (pack_id) => {
    const pack_data = await getDocDataById("prestation", pack_id);
    const pack_documents = pack_data.documents || [];
    const pack_documents_options = pack_documents.map((doc) => {
      return { value: doc.id, label: doc.name };
    });
    setPackDocuments(pack_documents_options);
    setPack(pack_id);

    let couples = {};
    for (let doc of documents) {
      for (let pack_doc of pack_documents) {
        if (doc.name === pack_doc.name) {
          couples[doc.id] = pack_doc.id;
        }
      }
    }
    setCouples(couples);
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  const setCouple = (doc, value) => {
    setCouples({ ...couples, [doc.id]: value });
  };

  const [step, setStep] = useState(1);

  const handleConvert = async () => {
    setLoadingData(true);

    const token = await getOrRefreshFirebaseToken();

    await modifyFolderPackBasic(folder.id, pack, couples, token, prefix);

    await addActivityLog(
      "Prestation dossier modifiée",
      folder.ref,
      orgData.id,
      userData.id,
      "folder_pack_modified",
      prefix
    );

    handleClickVariant("Le dossier a été converti avec succès", "success");

    await onUpdate();
    onClose();
    setLoadingData(false);
  };

  return (
    <div className=" flex items-center justify-center">
      <div className="flex  flex-col h-fit  bg-white rounded-3xl  w-full min-w-c500 max-h-[80vh] max-w-[80vw] overflow-y-auto">
        <div className=" text-h3 h-fit flex border-b-1 p-4 flex-row justify-between">
          Changer la prestation du dossier
          <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
            Fermer
          </div>
        </div>
        <div className="flex flex-col p-4 bg-neutral-50">
          {step === 1 && (
            <>
              <div className="w-c300 text-h3 text-shadow_50 mb-4">
                Sélectionnez une prestation pour remplacer la prestation de ce
                dossier et modifier ses documents.
              </div>
              <div className="w-c300 text-h3 text-shadow_50 mb-14">
                Vous pourrez faire correspondre les documents du dossier avec
                ceux de la nouvelle prestation dans l'étape suivante.
              </div>

              <DropDownGPT03
                label="Prestation"
                className="w-full"
                value={pack}
                items={packs}
                onChange={(e) => changePack(e.value)}
              ></DropDownGPT03>
              <Space y={10} />
            </>
          )}
          {step === 2 && (
            <div className="flex flex-col gap-1 h-fit">
              <Space y={5} />
              <div className="w-c500 text-h3 text-shadow_50">
                Faites correspondre les documents du dossier avec ceux de la
                nouvelle prestation pour transférer les fichiers déposés.{" "}
              </div>
              <div className="text-red-500 text-h3 w-c500 bg-red-50 border-1 border-red-200 mt-2 p-4 rounded-lg">
                Les documents du dossier qui n'ont pas de correspondance ne
                seront pas transférés.
              </div>
              <Space y={15} />
              {documents.map((doc) => (
                <div
                  key={doc.id}
                  className="flex flex-row items-center gap-2 h-fit"
                >
                  <div className="text-h3 text-shadow_50 w-c300 h-fit">
                    {doc.name}
                  </div>
                  <DropDownGPT03
                    className="w-full bg-white"
                    value={couples[doc.id] ? couples[doc.id] : ""}
                    items={pack_documents}
                    onChange={(e) => setCouple(doc, e.value)}
                  ></DropDownGPT03>
                </div>
              ))}{" "}
              <Space y={15} />
            </div>
          )}
        </div>
        <div className="border-t-1 p-4 flex flex-row justify-end">
          {step === 1 ? (
            <PrimaryButton onClick={() => setStep(2)}>Continuer</PrimaryButton>
          ) : (
            <WarningButton onClick={handleConvert} disabled={loadingData}>
              Initier la convertion <SmallSpinner loading={loadingData} />
            </WarningButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConvertBasic;
